<template>
  <header class="text-center mb-12">
    <p
      class="inline-block text-[0.8125rem] font-bold tracking-[0.08em] uppercase px-4 py-[0.35rem] rounded-full mb-[0.875rem]"
      :class="dark ? 'text-[#111] bg-[#FFD500]' : 'text-[#7a5f00] bg-[#FFF3B0]'"
    >
      {{ eyebrow }}
    </p>
    <h2
      :id="headingId"
      class="text-[clamp(1.75rem,4vw,2.5rem)] font-black leading-[1.15] mb-3"
      :class="dark ? 'text-white' : 'text-[#111]'"
    >
      {{ title }}
    </h2>
    <p
      v-if="subtitle"
      class="text-[1.0625rem] leading-[1.7] max-w-[560px] mx-auto"
      :class="dark ? 'text-white/60' : 'text-[#444]'"
    >
      {{ subtitle }}
    </p>
  </header>
</template>

<script setup>
defineProps({
  eyebrow:   { type: String, required: true },
  title:     { type: String, required: true },
  subtitle:  { type: String, default: '' },
  headingId: { type: String, default: '' },
  dark:      { type: Boolean, default: false },
})
</script>
